import { type JSX, useId } from "react";
import { DataSourceProvider } from "common";
import { getDataSourceTitle } from "@via/pages/data/data-collections/components/data-source-title.tsx";

/**
 * The Source cell of the dataset file table. `provider` is the stored DataSourceProvider key
 * ("SSH", "Amazon", ...); `name` is the bookmark name captured when the file was added. A file
 * added before sources were recorded has neither and shows nothing. A value this build does not
 * know is shown as plain text rather than as a broken logo. Every cell gets its own tooltip id,
 * because many rows usually share one bookmark name.
 */
export default function FileSourceCell({
  provider,
  name,
}: {
  provider?: unknown;
  name?: unknown;
}): JSX.Element | null {
  const tooltipId = `tooltip-file-source-${useId()}`;
  if (typeof provider !== "string" || provider === "") return null;
  const value = DataSourceProvider[provider as keyof typeof DataSourceProvider];
  if (typeof value !== "number") return <>{provider}</>;
  return getDataSourceTitle(
    typeof name === "string" && name !== "" ? { name } : null,
    value,
    tooltipId
  );
}
